import { render, staticRenderFns } from "./StepDoisDocumentacao.vue?vue&type=template&id=25d427ca"
import script from "./StepDoisDocumentacao.vue?vue&type=script&lang=js"
export * from "./StepDoisDocumentacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports